import React, { useState } from 'react';
import { Button } from '../ui/button';
import { ArrowRight, X } from 'lucide-react';
import { WHATSAPP_URL } from '../../lib/utils';
import LeadForm from './LeadForm';

export const CTASection = ({
  title = 'Sua operação médica pode ser mais eficiente.',
  description = 'A Apex Medical Hub ajuda clínicas e consultórios com gestão, finanças, faturamento, indicadores e estratégia.',
  buttonText = 'Quero falar com a Apex',
  variant = 'default',
  className = '',
}) => {
  const [showForm, setShowForm] = useState(false);

  const variants = {
    default: {
      bg: 'bg-gradient-to-r from-[#1e4e7e] to-[#007f73]',
      text: 'text-white',
      button: 'bg-white text-[#1e4e7e] hover:bg-white/90',
    },
    light: {
      bg: 'bg-slate-50',
      text: 'text-slate-900',
      button: 'btn-primary',
    },
    dark: {
      bg: 'bg-slate-900',
      text: 'text-white',
      button: 'bg-[#5cc1b0] text-slate-900 hover:bg-[#5cc1b0]/90',
    },
  };

  const style = variants[variant];

  return (
    <>
      <section className={`${style.bg} ${className}`} data-testid="cta-section">
        <div className="container-apex py-10 md:py-14 lg:py-16">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className={`font-heading text-2xl md:text-3xl lg:text-4xl font-bold mb-4 ${style.text}`}>
              {title}
            </h2>
            <p className={`text-lg mb-8 ${variant === 'default' ? 'text-white/80' : variant === 'dark' ? 'text-white/70' : 'text-slate-600'}`}>
              {description}
            </p>
            <Button
              size="lg"
              className={`${style.button} rounded-md px-8 py-6 text-base font-semibold`}
              data-testid="cta-button"
              onClick={() => setShowForm(true)}
            >
              {buttonText}
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </div>
        </div>
      </section>

      {/* Lead capture modal */}
      {showForm && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
          onClick={(e) => { if (e.target === e.currentTarget) setShowForm(false); }}
          data-testid="cta-lead-modal"
        >
          <div className="relative w-full max-w-md animate-in fade-in zoom-in-95 duration-200">
            <button
              onClick={() => setShowForm(false)}
              className="absolute -top-3 -right-3 z-10 w-8 h-8 rounded-full bg-white shadow-lg flex items-center justify-center hover:bg-slate-100 transition-colors"
              data-testid="cta-modal-close"
            >
              <X className="w-4 h-4 text-slate-600" />
            </button>
            <LeadForm
              title="Fale com um especialista"
              description="Preencha seus dados e entraremos em contato. Ou siga direto para o WhatsApp após o envio."
              source="cta-section"
              onSuccess={() => {
                setTimeout(() => {
                  window.open(WHATSAPP_URL, '_blank');
                  setShowForm(false);
                }, 1500);
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default CTASection;
